import React from 'react';

import { BrowserRouter } from 'react-router-dom';

import { NavermapsProvider } from 'react-naver-maps';

import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import { GlobalStyle } from './styles/globalStyle';
import { ThemeProvider } from 'styled-components';
import { MuiTheme } from './styles/muiTheme';
import theme from './styles/theme';
import MainRoute from '@/MainRoute';

function App() {
  return (
    <BrowserRouter>
      <NavermapsProvider ncpClientId="x4rth3tezw">
        <StyledEngineProvider injectFirst>
          <MuiThemeProvider theme={MuiTheme}>
            <CssBaseline enableColorScheme />
            <GlobalStyle />
            <ThemeProvider theme={theme}>
              <MainRoute />
            </ThemeProvider>
          </MuiThemeProvider>
        </StyledEngineProvider>
      </NavermapsProvider>
    </BrowserRouter>
  );
}

export default App;
